import { Settings } from 'Lib/components/common/table/controls/index';
import * as actions from '~/services/ui/actions';

function SettingsButton() {
    return <Settings actions={actions} sx={theme => ({ mr: 2, [theme.breakpoints.down('md')]: { background: 'none', border: '0' } })} />;
}

export { SettingsButton };
